import React from 'react';

const Loader = () => {
  return (
    <div>Loading... please wait.</div>
  )
}

export default Loader;